export default function SideNavReducer(state = { open: false }, action) {
  switch (action.type) {
    case "SIDE_NAV_TOGGLE":
      return { open: action.open }
    default:
      return state
  }
}
